import React from 'react';
import ApplicationLayout from "../../../layouts/ApplicationLayout";
import tapIcon from '../../../services/TapIcon';

export default class PageNotAuthorize extends React.Component {

    render() {
          return (<ApplicationLayout>
              <div className='center'>
                  <div className='py-2'> <tapIcon.FontAwesomeIcon icon={tapIcon.faLock} className='fa-4x fs-3' color='#45BEA9'/></div>
                  <p className='py-3 fs-3'>You do not have permission to view this page</p>
              </div>
            </ApplicationLayout>);
    }
}
 